var _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWalmartWishlist = function SvgWalmartWishlist(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 158.58 158.58",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.29,
    cy: 79.29,
    r: 79.29,
    fill: "#007ae0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m79.36,27.58h1.28c2.64,0,6.96,2.14,6.96,4.79l-2.18,25.24c0,2.64-2.14,4.79-4.79,4.79h-1.28c-2.64,0-4.79-2.14-4.79-4.79l-1.77-25.67c0-2.64,3.91-4.35,6.56-4.35Z",
    fill: "#ffb400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m81.04,131.58h-1.28c-2.64,0-6.96-2.14-6.96-4.79l2.18-25.24c0-2.64,2.14-4.79,4.79-4.79h1.28c2.64,0,4.79,2.14,4.79,4.79l1.77,25.67c0,2.64-3.91,4.35-6.56,4.35Z",
    fill: "#ffb400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m125.05,53.39l.65,1.1c1.34,2.28,1.68,7.09-.6,8.43l-22.87,10.9c-2.28,1.34-5.21.58-6.55-1.7l-.65-1.1c-1.34-2.28-.58-5.21,1.7-6.55l21.24-14.53c2.28-1.34,5.73,1.17,7.07,3.45Z",
    fill: "#ffb400"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m36.22,107.51l-.65-1.1c-1.34-2.28-1.68-7.09.6-8.43l22.87-10.9c2.28-1.34,5.21-.58,6.55,1.7l.65,1.1c1.34,2.28.58,5.21-1.7,6.55l-21.24,14.53c-2.28,1.34-5.73-1.17-7.07-3.45Z",
    fill: "#ffb400"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m125.1,105.5l-.64,1.1c-1.33,2.28-5.36,4.93-7.64,3.6l-20.7-14.6c-2.28-1.33-3.05-4.26-1.72-6.55l.64-1.1c1.33-2.28,4.26-3.05,6.55-1.72l23.07,11.41c2.28,1.33,1.79,5.57.45,7.86Z",
    fill: "#ffb400"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m34.43,54.53l.64-1.1c1.33-2.28,5.36-4.93,7.64-3.6l20.7,14.6c2.28,1.33,3.05,4.26,1.72,6.55l-.64,1.1c-1.33,2.28-4.26,3.05-6.55,1.72l-23.07-11.41c-2.28-1.33-1.79-5.57-.45-7.86Z",
    fill: "#ffb400"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWalmartWishlist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/walmart-wishlist.50bb705c.svg";
export { ForwardRef as ReactComponent };